import React from "react";
import Calendar from "../../../images/calendar2.svg";
import "../../../stylesheet/forms.css";
import { RiCloseLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";

const NoteView = ({ onClose, details, editNote }) => {
  return (
    <>
      {
        <>

          <dialog>
            <div className="w-full lg:w-[700px] bg-white rounded-md border relative">
              <section className="font-euclid-circular-a w-full relative ">
                <div className="w-full bg-primary rounded-t-md p-4">
                  <div className="flex justify-between w-full align-middle">
                    <h2 className="text-white text-xl font-semibold leading-7 tracking-wide p-8">
                      {"View Note"}
                    </h2>

                    <div className="flex justify-end items-center gap-10 w-full my-6 text-white">
                      <button onClick={() => editNote()}>
                        <FiEdit size={30} />
                      </button>

                      <button onClick={onClose}>
                        {" "}
                        <RiCloseLine size={32} />{" "}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="h-[700px] overflow-auto">
                  <form
                    id="note_view"
                    className="bg-white p-4 lg:p-8 justify-center gap-8
               overflow-auto"
                  >
                    <div className="ml-4 my-6 flex gap-10 items-center note_title">
                      <div className="w-3.5 h-3.5 bg-sky-500 rounded-[5px]" />
                      <p className="text-black text-[32px] font-medium">
                        {details?.title || "-"}
                      </p>
                    </div>

                    <div className="ml-[9px] my-6 flex gap-10 items-center">
                      <img src={Calendar} alt="calendar icon" />
                      <span>{details?.date || "-"}</span>
                    </div>

                    <div className="w-full lg:w-[582px] my-6 h-[154px] border border-neutral-600 p-4 ">
                      <p className="text-black text-sm font-bold">
                        Chief complainants <br /> <br />
                        <span className="text-gray-600 text-sm font-medium">
                          {details?.compliants}
                        </span>
                      </p>
                    </div>

                    <div className="w-full lg:w-[582px] my-6 h-[154px] border border-neutral-600 p-4 ">
                      <p className="text-black text-sm font-bold">
                        On Investigation <br /> <br />
                        <span className="text-gray-600 text-sm font-medium">
                          {details?.findings}
                        </span>
                      </p>
                    </div>

                    <div className="w-full lg:w-[582px] my-6 h-[154px] border border-neutral-600 p-4 ">
                      <p className="text-black text-sm font-bold">
                        Diagnosis <br /> <br />
                        <span className="text-gray-600 text-sm font-medium">
                          {details?.diagnosis}
                        </span>
                      </p>
                    </div>
                    <div className="w-full lg:w-[582px] my-6 h-[154px] border border-neutral-600 p-4 ">
                      <p className="text-black text-sm font-bold">
                        Procedure <br /> <br />
                        <span className="text-gray-600 text-sm font-medium">
                          {details?.procedure}
                        </span>
                      </p>
                    </div>
                  </form>
                </div>
              </section>
            </div>
          </dialog>
        </>
      }
    </>
  );
};

export default NoteView;
